import { ReactComponent as FlagIcon } from "assets/icons/new/flag.svg";

const getTypeIcon = (type) => {
  switch (type) {
    case "flag":
      return <FlagIcon />;
    default:
      return null;
  }
};

export { getTypeIcon };
